import "./index.scss"
import { CustomLink } from "custom";
import { Fragment } from "react";


interface Props {
}

export function Ad(props: Props) {
    return (
        <div className="max-width p-x desktop">
            <div className="ad">
                <div className="ad-left">
                    <div className="ad-left__title">
                        <span className="ad-left__title-dark">100% natural quality</span> organic product
                    </div>
                    <p className="ad-left__body">
                        See Our latest discounted products from here and get a special <a href="#discount" className="discount">discount product</a>
                    </p>
                </div>
                <CustomLink name="category" cat_name="organic-food" className="ad-right">
                    <Fragment>
                        shop now
                    </Fragment>
                </CustomLink>
            </div>
        </div>
    )
}
